import React from 'react'
import { Link } from 'react-router-dom'

const News = () => {
  return (
    <section className="news-section alternate bg-none">
    <div className="auto-container">
      <div className="row">
        {/* News Block Four */}
        <div className="news-block style-four col-lg-4 col-md-6 col-sm-12 wow fadeInRight">
          <div className="inner-box">
            <div className="image-box">
              <span className="tag">Participants</span>
              <figure className="image">
                <Link  to="blog-single.html">
                  <img src="/assets/images/resource/news-1.jpg" alt="" />
                </Link> 
              </figure>
            </div>
            <div className="lower-content">
              <div className="author">
                <figure className="thumb">
                  <img src="/assets/images/resource/author-thumb-1.jpg" alt="" />
                </figure>
                <h5 className="name">Thomas Albart</h5>
              </div>
              <ul className="post-info">
                <li>
                  <span className="far fa-calendar" /> 31/12/2023
                </li>
                <li>
                  <span className="far fa-comments" /> 02 Comments
                </li>
              </ul>
              <h4>
                <Link  to="blog-single.html">
                  Chances are Good That There’s a Cloud Software as{" "}
                </Link> 
              </h4>
              <div className="text">
                Single stroke at the present moment and yet I feel that lorem quis
                bibendum auctor.
              </div>
            </div>
          </div>
        </div>
        {/* News Block Four */}
        <div
          className="news-block style-four col-lg-4 col-md-6 col-sm-12 wow fadeInRight"
          data-wow-delay="400ms"
        >
          <div className="inner-box">
            <div className="image-box">
              <span className="tag">Virtual</span>
              <figure className="image">
                <Link  to="blog-single.html">
                  <img src="/assets/images/resource/news-2.jpg" alt="" />
                </Link> 
              </figure>
            </div>
            <div className="lower-content">
              <div className="author">
                <figure className="thumb">
                  <img src="/assets/images/resource/author-thumb-2.jpg" alt="" />
                </figure>
                <h5 className="name">Jamika Lora</h5>
              </div>
              <ul className="post-info">
                <li>
                  <span className="far fa-calendar" /> 31/12/2023
                </li>
                <li>
                  <span className="far fa-comments" /> 02 Comments
                </li>
              </ul>
              <h4>
                <Link  to="blog-single.html">
                  Chances are Good That There’s a Cloud Software as{" "}
                </Link> 
              </h4>
              <div className="text">
                Single stroke at the present moment and yet I feel that lorem quis
                bibendum auctor.
              </div>
            </div>
          </div>
        </div>
        {/* News Block Four */}
        <div
          className="news-block style-four col-lg-4 col-md-6 col-sm-12 wow fadeInRight"
          data-wow-delay="800ms"
        >
          <div className="inner-box">
            <div className="image-box">
              <span className="tag">Marketing</span>
              <figure className="image">
                <Link  to="blog-single.html">
                  <img src="/assets/images/resource/news-3.jpg" alt="" />
                </Link> 
              </figure>
            </div>
            <div className="lower-content">
              <div className="author">
                <figure className="thumb">
                  <img src="/assets/images/resource/author-thumb-3.jpg" alt="" />
                </figure>
                <h5 className="name">Nicky Monitor</h5>
              </div>
              <ul className="post-info">
                <li>
                  <span className="far fa-calendar" /> 31/12/2023
                </li>
                <li>
                  <span className="far fa-comments" /> 02 Comments
                </li>
              </ul>
              <h4>
                <Link  to="blog-single.html">
                  We Have Top Executive and Start Up Here Event 2023
                </Link> 
              </h4>
              <div className="text">
                Single stroke at the present moment and yet I feel that lorem quis
                bibendum auctor.
              </div>
            </div>
          </div>
        </div>
        {/* News Block Four */}
        <div className="news-block style-four col-lg-4 col-md-6 col-sm-12 wow fadeInRight">
          <div className="inner-box">
            <div className="image-box">
              <span className="tag">Participants</span>
              <figure className="image">
                <Link  to="blog-single.html">
                  <img src="/assets/images/resource/news-1.jpg" alt="" />
                </Link> 
              </figure>
            </div>
            <div className="lower-content">
              <div className="author">
                <figure className="thumb">
                  <img src="/assets/images/resource/author-thumb-1.jpg" alt="" />
                </figure>
                <h5 className="name">Thomas Albart</h5>
              </div>
              <ul className="post-info">
                <li>
                  <span className="far fa-calendar" /> 31/12/2023
                </li>
                <li>
                  <span className="far fa-comments" /> 02 Comments
                </li>
              </ul>
              <h4>
                <Link  to="blog-single.html">
                  Chances are Good That There’s a Cloud Software as{" "}
                </Link> 
              </h4>
              <div className="text">
                Single stroke at the present moment and yet I feel that lorem quis
                bibendum auctor.
              </div>
            </div>
          </div>
        </div>
        {/* News Block Four */}
        <div
          className="news-block style-four col-lg-4 col-md-6 col-sm-12 wow fadeInRight"
          data-wow-delay="400ms"
        >
          <div className="inner-box">
            <div className="image-box">
              <span className="tag">Virtual</span>
              <figure className="image">
                <Link  to="blog-single.html">
                  <img src="/assets/images/resource/news-2.jpg" alt="" />
                </Link> 
              </figure>
            </div>
            <div className="lower-content">
              <div className="author">
                <figure className="thumb">
                  <img src="/assets/images/resource/author-thumb-2.jpg" alt="" />
                </figure>
                <h5 className="name">Jamika Lora</h5>
              </div>
              <ul className="post-info">
                <li>
                  <span className="far fa-calendar" /> 31/12/2023
                </li>
                <li>
                  <span className="far fa-comments" /> 02 Comments
                </li>
              </ul>
              <h4>
                <Link  to="blog-single.html">
                  Chances are Good That There’s a Cloud Software as{" "}
                </Link> 
              </h4>
              <div className="text">
                Single stroke at the present moment and yet I feel that lorem quis
                bibendum auctor.
              </div>
            </div>
          </div>
        </div>
        {/* News Block Four */}
        <div
          className="news-block style-four col-lg-4 col-md-6 col-sm-12 wow fadeInRight"
          data-wow-delay="800ms"
        >
          <div className="inner-box">
            <div className="image-box">
              <span className="tag">Marketing</span>
              <figure className="image">
                <Link  to="blog-single.html">
                  <img src="/assets/images/resource/news-3.jpg" alt="" />
                </Link> 
              </figure>
            </div>
            <div className="lower-content">
              <div className="author">
                <figure className="thumb">
                  <img src="/assets/images/resource/author-thumb-3.jpg" alt="" />
                </figure>
                <h5 className="name">Nicky Monitor</h5>
              </div>
              <ul className="post-info">
                <li>
                  <span className="far fa-calendar" /> 31/12/2023
                </li>
                <li>
                  <span className="far fa-comments" /> 02 Comments
                </li>
              </ul>
              <h4>
                <Link  to="blog-single.html">
                  We Have Top Executive and Start Up Here Event 2023
                </Link> 
              </h4>
              <div className="text">
                Single stroke at the present moment and yet I feel that lorem quis
                bibendum auctor.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="styled-pagination mb-3">
        <ul>
          <li className="prev-post">
            <Link  to="#">
              <span className="fa fa-angle-left" />
            </Link> 
          </li>
          <li>
            <Link  to="#">1</Link> 
          </li>
          <li className="active">
            <Link  to="#">2</Link> 
          </li>
          <li>
            <Link  to="#">3</Link> 
          </li>
          <li className="next-post">
            <Link  to="#">
              <span className="fa fa-angle-right" />{" "}
            </Link> 
          </li>
        </ul>
      </div>
    </div>
  </section>
  
  )
}

export default News